import { Typography } from "@mui/material";
import { Modal } from "@mui/material";
import { CustomModalProps } from "../../../types";
import { useEffect, useState } from "react";
import { getTransactionDetails } from "../../../apis/buyer/transaction";
import {
  IAdminTransaction,
  IBuyerProperties,
  IBuyerTransaction,
} from "../../common/utils/interfaces";
import { formatDate } from "../../common/utils/helpers";

interface ApprovalModalProps extends CustomModalProps {
  property: IBuyerProperties;
}
const ApprovalModal: React.FC<ApprovalModalProps> = ({
  handleClose,
  open,
  property,
}) => {
  const [transactionDetails, setTransactionDetails] =
    useState<IAdminTransaction>();
  useEffect(() => {
    async function fetchTransactionDetails() {
      const response = await getTransactionDetails(
        property.property_purchase_reference
      );
      setTransactionDetails(response);
    }

    if (property) fetchTransactionDetails();
  }, []);

  const documentsUploaded = transactionDetails?.title_deed != null
  return (
    <Modal onClose={handleClose} open={open}>
      <div className="absolute p-6 max-h-[85vh] max-w-[88vw] overflow-auto space-y-10 bg-white top-[50%] translate-y-[-50%] left-[50%] translate-x-[-50%] w-[90%] sm:w-[1000px] outline-none">
        <div className="info-card !px-6 sm:px-10">
          <div className="info-card-header">
            <Typography variant="h5">Transaction details</Typography>
          </div>
          <div className="grid gap-y-6 sm:grid-cols-2">
            <div className="grid gap-4 sm:gap-7">
              <div className="_section">
                <div className="_title">
                  <Typography>Property Name</Typography>
                </div>
                <div className="_data">
                  <Typography style={{ textTransform: "capitalize" }}>
                    {transactionDetails?.listing.name}
                  </Typography>
                </div>
              </div>
              <div className="_section">
                <div className="_title">
                  <Typography>Address</Typography>
                </div>
                <div className="_data">
                  <Typography style={{ textTransform: "capitalize" }}>
                    {transactionDetails?.listing.full_address}
                  </Typography>
                </div>
              </div>
              <div className="_section">
                <div className="_title">
                  <Typography>Price</Typography>
                </div>
                <div className="_data">
                  <Typography style={{ textTransform: "capitalize" }}>
                    {transactionDetails?.listing.price}
                  </Typography>
                </div>
              </div>
            </div>
            <div className="grid gap-4 sm:gap-y-7">
              <div className="_section">
                <div className="_title">
                  <Typography>Payment Type</Typography>
                </div>
                <div className="_data">
                  <Typography style={{ textTransform: "capitalize" }}>
                    {transactionDetails?.purchase_request_payment_type_display}
                  </Typography>
                </div>
              </div>
              <div className="_section">
                <div className="_title">
                  <Typography>Transaction Date</Typography>
                </div>
                <div className="_data">
                  <Typography style={{ textTransform: "capitalize" }}>
                    {formatDate(transactionDetails?.created!)}
                  </Typography>
                </div>
              </div>
              <div className="_section">
                <div className="_title">
                  <Typography>Transaction ID</Typography>
                </div>
                <div className="_data">
                  <Typography style={{ textTransform: "capitalize" }}>
                    {transactionDetails?.reference_id}
                  </Typography>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="info-card !px-6 sm:px-10">
          <div className="info-card-header">
            <Typography variant="h5">Transaction Documents</Typography>
          </div>
          <div className="flex flex-col gap-y-5">
            <a href={transactionDetails?.sales_receipt} target="_blank" rel="noopener noreferrer">
              <div className="py-4 bg-[#CECECE]/10 rounded-2xl border-[#CECECE]/20 px-5 flex items-center">
                <img src="/assets/images/pdf-filled.svg" alt="" />
                <div className="ml-5 mr-auto">
                  <p>Official Sales Receipt</p>
                </div>
                <span className={`${documentsUploaded ? 'text-primary bg-[#DAFDE599]/60': 'text-[#363636] bg-[#D9D9D9]'} bg-[#DAFDE599]/60 bg-opacity-20 rounded-2xl px-4 py-1`}>
                  {documentsUploaded ? 'Download' : 'Pending'}
                </span>
              </div>
            </a>
            <a href={transactionDetails?.letter_of_allotment} target="_blank" rel="noopener noreferrer">
              <div className="py-4 bg-[#CECECE]/10 rounded-2xl border-[#CECECE]/20 px-5 flex items-center">
                <img src="/assets/images/pdf-filled.svg" alt="" />
                <div className="ml-5 mr-auto">
                  <p>Letter of Allotment</p>
                </div>
                <span className={`${documentsUploaded ? 'text-primary bg-[#DAFDE599]/60': 'text-[#363636] bg-[#D9D9D9]'} bg-[#DAFDE599]/60 bg-opacity-20 rounded-2xl px-4 py-1`}>
                  {documentsUploaded ? 'Download' : 'Pending'}
                </span>
              </div>
            </a>
            <a href={transactionDetails?.letter_of_allocation} target="_blank" rel="noopener noreferrer">
              <div className="py-4 bg-[#CECECE]/10 rounded-2xl border-[#CECECE]/20 px-5 flex items-center">
                <img src="/assets/images/pdf-filled.svg" alt="" />
                <div className="ml-5 mr-auto">
                  <p>Letter of Allocation</p>
                </div>
                <span className={`${documentsUploaded ? 'text-primary bg-[#DAFDE599]/60': 'text-[#363636] bg-[#D9D9D9]'} bg-[#DAFDE599]/60 bg-opacity-20 rounded-2xl px-4 py-1`}>
                  {documentsUploaded ? 'Download' : 'Pending'}
                </span>
              </div>
            </a>
            <a href={transactionDetails?.sales_receipt} target="_blank" rel="noopener noreferrer">
              <div className="py-4 bg-[#CECECE]/10 rounded-2xl border-[#CECECE]/20 px-5 flex items-center">
                <img src="/assets/images/pdf-filled.svg" alt="" />
                <div className="ml-5 mr-auto">
                  <p>Title Deed</p>
                </div>
                <span className={`${documentsUploaded ? 'text-primary bg-[#DAFDE599]/60': 'text-[#363636] bg-[#D9D9D9]'} bg-[#DAFDE599]/60 bg-opacity-20 rounded-2xl px-4 py-1`}>
                  {documentsUploaded ? 'Download' : 'Pending'}
                </span>
              </div>
            </a>
          </div>
        </div>
        <div className="flex items-center justify-end space-x-4">
          <button className="bg-primary rounded-lg py-[10px] px-[30px] text-[#F8F8F8] font-semibold hover:opacity-70">
            APPROVE
          </button>
          <button className="bg-[#CD0101] rounded-lg py-[10px] px-[30px] text-[#F8F8F8] font-semibold hover:opacity-70">
            DENY
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ApprovalModal;
